import { render, staticRenderFns } from "./JobsRegistryList.vue?vue&type=template&id=6b874b4f"
import script from "./JobsRegistryList.vue?vue&type=script&lang=js"
export * from "./JobsRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports